import React from "react"
import game from "abalone.png"

const Abalone = props => <img src={game} className="game" {...props} />

export default Abalone
